import { Component } from '@angular/core';
import { FavoriteInfoLayoutComponent } from '../core/favoriteinfo.layout.component';
import { FeatureConstant } from '../../../constant/feature.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    selector: 'app-favoriteinfolayoutdesktop',
    templateUrl: './favoriteinfo.layout.desktop.component.html',
    styleUrls: ['../css/favoriteinfo.layout.desktop.component.scss'],
    standalone: false
})
export class FavoriteInfoLayoutDesktopComponent extends FavoriteInfoLayoutComponent {
  constructor(
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public _utilService: UtilService
  ) {
    super(firebaseAnalyticsServices, _utilService);
    this.deviceImage = {
      '1_desktop': 'favorites_fcb_icon@2x',
      '5_desktop': '5h_desktop_landscape_white@2x',
      '7_desktop': '7h_desktop_landscape_white@2x',
      '5_device_landscape': '5h_mobile_landscape_white@2x',
      '7_device_portrait': '7h_desktop_landscape_white@2x',
      '7_device_landscape': '7h_desktop_landscape_white@2x',
      '3_device_landscape': '3h_mobile_landscape_white@2x',
      '2_device_portrait': '2h_mobile_portrait_white@2x',
    };
  }
  ngOnInit() {
    super.ngOnInit();
    this.currentLanguage = this.data.currentLanguage;
  }

  ngOnChanges() {
    super.ngOnChanges();
    this.currentLanguage = this.data.currentLanguage;
  }

  computeFavoriteList() {
    const loc_Favorites = [];
    this.favoritesList = [];
    this.userCurrency = this.data.userCurrency;
    for (let i = 0; i < 6; i++) {
      // console.log('this.data.favoriteList[i]');
      // console.log(this.data.favoriteList[i]);
      if (this.data.favoriteList[i]) {
        const obj: any = Object.assign({}, this.data.favoriteList[i]);
        obj.gameType = FeatureConstant[(obj.tableType + '_lang').toUpperCase()];
        obj.select = 0;
        if (obj.device === undefined) {
          if (parseInt(obj.seatavailable, 10) === 5) {
            obj.device = 'desktop';
          } else if (parseInt(obj.seatavailable, 10) === 3) {
            obj.device = 'device_landscape';
          } else if (parseInt(obj.seatavailable, 10) === 2) {
            obj.device = 'device_portrait';
          }
        }
        loc_Favorites.push(obj);
      }
    }
    this.favoritesList = [...loc_Favorites];
    //console.log('this.favoritesList');
    //console.log(this.favoritesList);
  }

  onMouseOver = (index) => {
    this.favoritesList[index].select = 1;
  };
  onMouseOut = (index) => {
    this.favoritesList[index].select = 0;
  };
}
